import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-loading',
  templateUrl: './split-loading.component.html',
  styleUrls: ['./split-loading.component.scss']
})
export class SplitLoadingComponent {
  @Input() loading: boolean = false;
}
